import { pro1, pro2, pro3, pro4, pro5, pro6, segog11, segog12, segog3, sinkropro1, sinkropro2, sinkropro4, sinkrow6, staaw10, staaw11} from '../../../images/images';

export const prodataAr = [
	{
		id: 5,
		img: pro4,
		link: pro4,
		des: 'نجاح صيانة اللوحه الأم',
		dep:'سيغوغ'
	},

	{
		id: 6,
		img: segog11,
		link: segog11,
		des: 'عملية صيانة قرص صلب',
		dep:'سيغوغ'
	},

	{
		id: 7,
		img: segog12,
		link: segog12,
		des: 'نجاح صيانه قرص صلب',
		dep:'سيغوغ'
	},

	{
		id: 8,
		img: segog3,
		link: segog3,
		des: 'نجاح صيانة حاسب جامعه المنيا',
		dep:'سيغوغ'
	},

	{
		id: 1,
		img: pro1,
		link: 'https://saske-store.netlify.app',
		des: 'مشروع متجر الاصدار الاول',
		dep:'ساكودي'
	},

	{
		id: 2,
		img: pro3,
		link: 'https://sultan-pasha.github.io/hotel/',
		des: 'مشروع الفندق الاصدار الرابع',
		dep:'ساكودي'
	},


	{
		id: 16,
		img: pro6,
		link: pro6,
		des: 'من اعمالنا مع شركة موجود الناشئه',
		dep:'ساكودي'
	},

	{
		id: 3,
		img: pro5,
		link: 'https://sultan-pasha.github.io/hospitalsite/',
		des: 'مشروع المستشفي الاصدار الاول',
		dep:'ساكودي'
	},

	{
		id: 4,
		img: pro2,
		link: pro2,
		des: 'الكود المصدري لمشروع المدرسه',
		dep:'ساكودي'
	},

	{
		id: 9,
		img: sinkropro1,
		link: sinkropro1,
		des: 'خادمنا الاحتياطي',
		dep:'سينكرو'
	},

	{
		id: 10,
		img: sinkropro2,
		link: sinkropro2,
		des: 'عملياتنا علي خادمنا الاحتياطي',
		dep:'سينكرو'
	},

	{
		id: 11,
		img: sinkropro4,
		link: sinkropro4,
		des: 'إعادة هيكلة خوادم جامعة المنيا',
		dep:'سينكرو'
	},

	{
		id: 12,
		img: sinkrow6,
		link: sinkrow6,
		des: 'خادمنا للتحكم بالشبكه',
		dep:'سينكرو'
	},

	{
		id: 14,
		img: staaw10,
		link: 'https://5e7c20b09420a.site123.me/',
		des: 'متجرنا لتقديم كاقة منتجاتنا و خدماتنا',
		dep:'ستاوو'
	},

	{
		id: 15,
		img: staaw11,
		link: staaw11,
		des: 'بعض من طلبات عملائنا',
		dep:'ستاوو'
	},
	
];